// Registr grafických skinů. Skin se volí per liga (League.skinId) a aplikuje se na
// celé on-air vysílání přepnutím CSS třídy na #layer-container (viz broadcast-layer).
export type SkinId = 'default' | 'EC23' | 'ODM';

export interface SkinDef {
  id: SkinId;
  name: string;
  // CSS třída nasazená na kořenový kontejner; prázdná = výchozí vzhled.
  cssClass: string;
  // ODM norma: ve vysílací grafice se loga týmů nepoužívají, jen 3písmenné kódy.
  hideTeamLogos: boolean;
  // Barva pro plochu, která by jinak nesla barvu týmu, ale nemá ji z čeho vzít:
  // tým nemá nastavený primaryColor (ball-score-server ho při autodiscovery
  // záměrně nenastavuje — viz jeho wbsc.ts), nebo se guid nespároval s žádným
  // týmem v configu. Dřív to byla dvakrát zadrátovaná '#333333' v util.service;
  // patří to ke skinu, protože je to jeho vzhled.
  neutralColor: string;
}

export const SKINS: SkinDef[] = [
  {id: 'default', name: 'Výchozí', cssClass: '', hideTeamLogos: false, neutralColor: '#333333'},
  {id: 'EC23', name: 'EC23', cssClass: 'skin-ec23', hideTeamLogos: false, neutralColor: '#333333'},
  // ODM barvy týmů nepoužívá vůbec, takže jeho neutrál je přímo černá plocha,
  // kterou skin kreslí i tam, kde tým barvu má.
  {id: 'ODM', name: 'ODM', cssClass: 'skin-odm', hideTeamLogos: true, neutralColor: '#000000'},
];

export const DEFAULT_SKIN: SkinDef = SKINS[0];

export function getSkinById(skinId?: string): SkinDef | undefined {
  return SKINS.find(s => s.id === skinId);
}
